import React from 'react'
import { Redirect, Switch } from 'react-router-dom'

export default function RedirectTo() {
  return (
    <Switch>
      {/* 待指向具体的路由 */}
      <Redirect to="/login" />
    </Switch>
  )
}
